export const formatDate = (date) => {
    date = date ? new Date(date) : new Date();
    var dd = String(date.getDate()).padStart(2, '0');
    var mm = String(date.getMonth() + 1).padStart(2, '0'); //January is 0!
    var yyyy = date.getFullYear();
    let formattedDate = mm + '/' + dd + '/' + yyyy;
    return formattedDate;
}

export const formatDateTime = (date) => {

    date = date ? new Date(date) : new Date();
    var dd = String(date.getDate());
    var mm = String(date.getMonth() + 1); //January is 0!
    var yyyy = date.getFullYear();
    let formattedDate = mm + '/' + dd + '/' + yyyy;
    var hours = date.getHours() > 12 ? date.getHours() - 12 : date.getHours();
    var am_pm = date.getHours() >= 12 ? "pm" : "am";
    hours = hours < 10 ? "0" + hours : hours;
    var minutes = date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes();
    var seconds = date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
    var time = formattedDate + " " + hours + ":" + minutes + ":" + seconds + " " + am_pm;
    return time;
}


export const format_Date = function formatDate(date) {
    date = date ? new Date(date) : new Date();
    var dd = String(date.getDate()).padStart(2, '0');
    var mm = String(date.getMonth() + 1).padStart(2, '0'); //January is 0!
    var yyyy = date.getFullYear();
    let formattedDate = yyyy + '-' + mm + '-' + dd;
    return formattedDate;
}

/**
 * Converts UTC date string to local date without timezone conversion
 * Handles the case where API returns "2025-09-30T00:00:00+00:00" 
 * and we want to display "2025-09-30" regardless of user's timezone
 * @param {string} utcDateString - UTC date string from API
 * @returns {Date} - Local date object representing the same calendar date
 */
export const convertUTCToLocalDate = (utcDateString) => {
    if (!utcDateString) return null;
    
    // Extract just the date part (YYYY-MM-DD) from UTC string
    const datePart = utcDateString.split('T')[0];
    
    // Create a new date using local timezone with the same calendar date
    // This prevents automatic timezone conversion
    const [year, month, day] = datePart.split('-').map(Number);
    return new Date(year, month - 1, day); // month is 0-indexed
}

/**
 * Formats effective date for display, handling UTC conversion issues
 * @param {string} effectiveDate - Date string from API (may include timezone info)
 * @returns {Date} - Properly formatted date for display
 */
export const formatEffectiveDate = (effectiveDate) => {
    if (!effectiveDate) return null;
    
    // If the date string includes timezone info (+00:00, Z, etc.), handle it specially
    if (effectiveDate.includes('+') || effectiveDate.includes('Z') || effectiveDate.includes('T')) {
        return convertUTCToLocalDate(effectiveDate);
    }
    
    // Otherwise, treat as regular date
    return new Date(effectiveDate);
}